export const roAboutText = (
  <div className="text1">
    <p>
      <b>
        ProTax Advisors — Partenerul dumneavoastră de Contabilitate de Încredere
      </b>
    </p>
    <p>
      Noi ne ocupăm de cifre, pentru ca dumneavoastră să vă puteți dezvolta
      afacerea.
    </p>
    <p>
      Bine ați venit la ProTax Advisors, locul unde gestionarea finanțelor
      dumneavoastră devine simplă, lipsită de stres și eficientă. Cu sediul în
      Londra și Bedfordshire, suntem specializați în a ajuta startup-urile,
      freelancerii și întreprinderile mici și mijlocii să își țină evidența
      cifrelor – astfel încât dumneavoastră să vă puteți concentra pe
      dezvoltarea afacerii.
    </p>
    <p>
      Echipa noastră este complet calificată și certificată, având acreditări
      profesionale în contabilitate, fiscalitate și contabilitate primară.
      Combinăm expertiza tehnică cu o abordare personalizată pentru a oferi
      servicii financiare precise, conforme și de încredere, adaptate nevoilor
      afacerii dumneavoastră.
    </p>
    <p>
      La ProTax Advisors, facem mai mult decât să vă gestionăm conturile –
      oferim îndrumare clară și sfaturi practice pentru a vă ajuta afacerea să
      prospere. De la evidența contabilă, salarizare și conformitatea fiscală,
      până la bugetare, previziuni și planificare financiară, contabilii noștri
      calificați se asigură că finanțele dumneavoastră sunt în ordine, iar
      afacerea dumneavoastră este poziționată pentru creștere.
    </p>
    <p>Colaborând cu ProTax Advisors, beneficiați de:</p>
    <ul>
      <li>
        Contabili calificați și certificați care înțeleg complexitățile
        finanțelor de afaceri.
      </li>
      <li>
        Suport personalizat, adaptat obiectivelor și nevoilor de raportare ale
        afacerii dumneavoastră
      </li>
      <li>Prețuri transparente, fixe, fără costuri ascunse.</li>
      <li>
        Instrumente digitale moderne pentru acces eficient și în timp real la
        datele dumneavoastră financiare.
      </li>
      <li>
        Noi gestionăm contabilitatea și conformitatea, astfel încât
        dumneavoastră să vă puteți concentra pe dezvoltarea afacerii.
      </li>
    </ul>
  </div>
);
